import getApiBaseUrl from '@/utils/getBaseUrl';
import { useQuery } from '@tanstack/react-query';
import useGetProfile from './useGetProfile';

interface Result {
  categories: string[];
  series: number[];
}

export default function useGetUserAnalytics(dateRange: string) {
  const { data: user } = useGetProfile();
  const token = window.localStorage.getItem('_token');

  return useQuery<Result>({
    queryKey: ['ADMIN_USER_ANALYTICS', dateRange],
    queryFn: async () => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/users/users/analytics?dateRange=${dateRange}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    enabled: user?.role === 'ADMIN',
  });
}
